<div class="h-screen grid grid-cols-1 md:grid-cols-[3fr_2fr]">
  <div class="flex flex-col justify-between p-4 sm:p-6 md:p-8">
    <app-nav-button></app-nav-button>
    <header class="flex flex-col w-full items-center mt-4">
      <img src="assets/icon/codijobs.png" class="h-14" alt="">
      <h1 class="text-2xl font-bold text-gray-700 text-center">
        Bienvenido a <span class="text-primary">Codijobs</span>
      </h1>
      <p class="mt-2 text-xl text-gray-600">Crea tu cuenta</p>
    </header>
    <section class="flex-1 mt-5 px-4 sm:px-8 md:px-16 lg:px-24 xl:px-36">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col justify-between gap-y-10">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <app-input-text label="Nombres" placeholder="Nombre" [control]="form.get('firstName')" />
          <app-input-text label="Apellidos" placeholder="Apellidos" [control]="form.get('lastName')" />
          <app-input-text label="Correo" placeholder="Correo electrónico" [control]="form.get('email')" />
          <app-input-text label="Contraseña" placeholder="Contraseña" [control]="form.get('password')"
            type="password" />
          <app-input-date label="Fecha de nacimiento" [control]="form.get('birthDate')">
          </app-input-date>
          <app-input-select label="Género" placeholder="Seleccione su sexo" [control]="form.get('sex')"
            [options]="sexOptions">
          </app-input-select>
          <app-input-text label="Número de teléfono" placeholder="Número de teléfono" [control]="form.get('telfOne')" />
          <app-input-text label="DNI" placeholder="DNI" [control]="form.get('identificationDocument')" />
        </div>
        <app-loading-button [text]="'Crear cuenta'" [loading]="loading" type="submit">
        </app-loading-button>
      </form>
      <div class="mt-4 text-center">
        <p class="text-sm text-gray-600">
          ¿Ya tienes una cuenta?
          <a routerLink="/login"
            class="text-primary cursor-pointer font-medium hover:underline transition duration-150 ease-in-out">
            Inicia sesión aquí
          </a>
        </p>
      </div>
    </section>
  </div>
  <div class="hidden relative md:block">
    <img src="assets/img/abs1.jpg" alt="Imagen decorativa" class="w-full h-full object-cover absolute" />
  </div>
</div>
